<template>
  <div @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
    <slot></slot>
  </div>
</template>

<style lang="less">
.tt-wrapper-tooltip {
  position: absolute;
  display: block;
  color: white;
  background: #3f3e3b;
  padding: 5px 10px;
  z-index: 3000;
  border-radius: 3px;
  box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.25);

  &:before {
    content: "";
    display: block;
    border: 10px solid transparent;
    border-bottom-color: #3f3e3b;
    border-top-width: 0;
    position: absolute;
    top: -10px;
    right: 10px;
  }
}
</style>

<script>
import jQuery from "jquery";

export default {
  data() {
    return {
      ttEl: null
    };
  },
  props: {
    text: {
      type: String
    }
  },
  methods: {
    handleMouseEnter() {
      if (this.ttEl === null) {
        this.ttEl = document.createElement("span");
        this.ttEl.innerText = this.text;
        document.body.appendChild(this.ttEl);
        let $wrapperEl = jQuery(this.$el);
        let wrapperPos = $wrapperEl.offset();
        let top = wrapperPos.top + $wrapperEl.height() + 10;
        let right = document.body.offsetWidth - wrapperPos.left - 52 + 5;
        this.ttEl.style.right = right + "px";
        this.ttEl.style.top = top + "px";
        this.ttEl.className = "tt-wrapper-tooltip";
        this.ttEl.addEventListener('mouseleave', this.handleMouseLeave);
      }
    },
    handleMouseLeave() {
      if (this.ttEl !== null) {
        document.body.removeChild(this.ttEl);
        this.ttEl = null;
      }
    }
  }
};
</script>
